export default __webpack_public_path__ + "37ef7210f3130974ea4ba8aa2bc8a2f2.svg";